export const GET_APP_COUNTRIES_START = 'GET_APP_COUNTRIES_START';
export const GET_APP_COUNTRIES_SUCCESS = 'GET_APP_COUNTRIES_SUCCESS';
export const GET_APP_COUNTRIES_ERROR = 'GET_APP_COUNTRIES_ERROR';
